/* eslint-disable unicorn/filename-case */
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import axiosClient from '@ui-core/config/axiosClient';
import { UserDataInterface } from '@ui-core/interfaces/UserDataInterface';
import axios from 'axios';
import { type Dispatch } from 'redux';

export interface UserDataState {
    error: boolean;
    errorMessage: string;
    loading: boolean;
    userData: UserDataInterface;
    wasFetched: boolean;
}

const initialState: UserDataState = {
    error: false,
    errorMessage: '',
    loading: false,
    userData: {} as UserDataInterface,
    wasFetched: false
};

export const userDataSlice = createSlice({
    initialState,
    name: 'userData',
    reducers: {
        clearUserDataError: (state) => {
            state.error = false;
            state.errorMessage = '';
        },
        loading: (state) => {
            state.loading = true;
            state.wasFetched = false;
            state.error = false;
            state.errorMessage = '';
        },
        userDataError: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = true;
            state.errorMessage = action.payload;
        },
        userDataSuccess: (state, action: PayloadAction<UserDataInterface>) => {
            state.loading = false;
            state.wasFetched = true;
            state.userData = action.payload;
        },
        setUserData: (state, action: PayloadAction<any>) => {
            state.userData = {
                ...state.userData,
                [action.payload.name]: action.payload.value
            };
        }
    }
});

export const {
    clearUserDataError,
    loading,
    userDataError,
    userDataSuccess,
    setUserData
} = userDataSlice.actions;

export const fetchUserDataThunk =
    () =>
    // eslint-disable-next-line unicorn/consistent-function-scoping
    async (dispatch: Dispatch): Promise<void> => {
        dispatch(loading());
        const axiosApi = axiosClient(
            `${import.meta.env.REACT_APP_HOME_API_URL}`
        );

        try {
            const response = await axiosApi.get('v1/usuario/datos-generales');
            dispatch(userDataSuccess(response.data));
        } catch (error: unknown) {
            if (axios.isAxiosError(error)) {
                console.log('Fetch user data error:', error.response);
                dispatch(userDataError(error.response?.data.message));
            }
        }
    };

export default userDataSlice.reducer;
